module.exports = __webpack_public_path__ + "static/media/about img2.165a0b98.webp";